import NavigationPage from "components/pages/NavigationPage"

export default function CaptureMabiMenuAccordion(props) {
    return <NavigationPage />
}